import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bb21d41&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6bb21d41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb21d41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb21d41')) {
      api.createRecord('6bb21d41', component.options)
    } else {
      api.reload('6bb21d41', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bb21d41&scoped=true&", function () {
      api.rerender('6bb21d41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/city-insurance-entry/index.vue"
export default component.exports